export enum LoginControlName {
  Login = 'login',
  Password = 'password'
}
